import { render, staticRenderFns } from "./GImage.vue?vue&type=template&id=792d09e9&scoped=true"
import script from "./GImage.vue?vue&type=script&lang=js"
export * from "./GImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792d09e9",
  null
  
)

export default component.exports